import _ from 'lodash';
import moment from 'moment';
import { push } from 'connected-react-router';
import API from '../helpers/api';

export function authorizeWithTicket({ query }) {
	return async dispatch => {
		if (!query || !query.ticket) {
			dispatch(push(`/login?path=${_.get(query, 'path') || ''}`));
			return;
		}
		const response = await API.auth.casAuth({ ticket: query.ticket, path: query.path });

		// cas ticket used and try again
		if (response.meta.code === 4033) {
			dispatch(push('/'));
			return;
		}

		// really unauthorized
		if (response.meta.code !== 200) {
			dispatch(push('/unauthorized'));
			return;
		}

		// store response
		localStorage.setItem('ldr_student', JSON.stringify({
			token: response.data.auth.token,
			user: response.data.user,
			last_login: moment()
		}));

		// Navigate to specified page
		if (query.path && query.path !== '/' && query.path !== '') {
			dispatch(push(query.path));
			return;
		}

		// Navigate to next page
		dispatch(push('/tickets'));
	};
}
